/**
 *
 * FBSectionHeader
 *
 */

import React, {memo} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// icons
// import CustomIcons from 'components/CustomIcons';

// antd component
// import { Button } from 'antd';

// components
import {
  FBExportButton
} from 'components/Communications';


function FBAnswersTabHeader({
  type,
  title,
  btnName,
  showExport,
  data,
  extraActoins,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-answer-tab-header', type, className);

  return (
    <div className="tcf-fb-answer-tab-header__wrapper">
      {type == 'appointments' && showExport && (
        <FBExportButton className={type} key="export-button" type={type} attachmentData={data} btnName={btnName} />
      )}
      <div {...rest} className={childClassNames}>
        {title && (
          <div className="header-wrapper">
            <div className={`header-title`}>{title}</div>
          </div>
        )}
        <div className="header-actions">
          {type == 'appointments' && extraActoins?.map(extr => extr)}
          {type == 'forms' && btnName && showExport && (
            <FBExportButton key="export-button" type={type} attachmentData={data} btnName={btnName} />
          )}
        </div>
      </div>
    </div>
  );
}

FBAnswersTabHeader.defaultProps = {
  type: 'forms',
  title: 'Réponses formulaire',
  showExport: true,
  btnName: 'Exporter les résultats',
};
FBAnswersTabHeader.propTypes = {
  type: PropTypes.oneOf(['appointments', 'forms']).isRequired,
  csvData: PropTypes.oneOfType([PropTypes.bool, PropTypes.array])
};

export default memo(FBAnswersTabHeader);
